import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilter as reportsDefaultFilter } from '../../../../../../../views/Reports/EditReports';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/')({
  validateSearch: zodValidator(withDefaults(schema.REPORTS, defaultFilter, reportsDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
